// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendor","react","fa","redux"], () => (__webpack_require__("./node_modules/core-js/index.js")))
__webpack_require__.O(undefined, ["vendor","react","fa","redux"], () => (__webpack_require__("./node_modules/regenerator-runtime/runtime.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor","react","fa","redux"], () => (__webpack_require__("./index.web.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
